import React, { useState } from "react";
import PropTypes from "prop-types";
// ui
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
// style
import { createStyles, makeStyles, styled, alpha } from "@material-ui/styles";
// component
import ButtonPlusBadge from "../button/ButtonPlusBadge";
// utils

//
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
  })
);

const StyledMenu = styled(Menu)(({ theme }) => ({
  "& .MuiPopover-paper": {
    width: "200px",
  },
}));

const renderMenuItem = (menuItems) =>
  menuItems.map(
    ({ children, useMenuItem = true, ...rest }, idx) =>
      (useMenuItem === false && children) || (
        <MenuItem key={idx.toString()} {...rest}>
          {children}
        </MenuItem>
      )
  );

//
const ButtonBadgePopup = ({ badgeProps, buttonProps, menuProps }) => {
  // style
  const classes = useStyles();
  // props
  const { header, body, footer, ...restMenuProps } = menuProps;

  // local state
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box>
      <ButtonPlusBadge
        badgeProps={badgeProps}
        buttonProps={{
          ...buttonProps,
          onClick: handleClick,
        }}
      />
      <StyledMenu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        {...restMenuProps}
      >
        {header && renderMenuItem(header)}
        {header && body && <Divider />}
        {body && renderMenuItem(body)}
        {body && footer && <Divider />}
        {footer && renderMenuItem(footer)}
      </StyledMenu>
    </Box>
  );
};

ButtonBadgePopup.propTypes = {
  badgeProps: PropTypes.objectOf(PropTypes.any),
  buttonProps: PropTypes.objectOf(PropTypes.any),
  menuProps: PropTypes.objectOf(PropTypes.any),
  badgeColor: PropTypes.string,
  badgeContent: PropTypes.node,
};

ButtonBadgePopup.defaultProps = {
  badgeProps: {},
  buttonProps: {},
  menuProps: {},
  badgeColor: "secondary",
  badgeContent: null,
};

export default ButtonBadgePopup;
